import { useState } from "react";

import { SmileFaceGrey } from "neetoicons";
import { Dropdown } from "neetoui";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

import EmojiPickerMenu from "./EmojiPickerMenu";

const EmojiPicker = ({ onSelect, dropdownProps, open = false }) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(open);

  const onEmojiClick = emoji => {
    setIsOpen(false);
    onSelect(emoji);
  };

  return (
    <Dropdown
      {...{ isOpen }}
      closeOnEsc
      closeOnSelect={false}
      dropdownProps={{ className: "neeto-ui-shadow-s z-10 overflow-x-hidden" }}
      position="bottom-start"
      strategy="fixed"
      buttonProps={{
        "data-testid": "emoji-picker-dropdown-icon",
        "aria-haspopup": "dialog",
        icon: SmileFaceGrey,
        tooltipProps: {
          content: t("neetoMolecules.common.emojiPicker"),
          position: "top",
          touch: ["hold", 500],
        },
        onClick: () => setIsOpen(true),
        style: "text",
      }}
      onClickOutside={() => setIsOpen(false)}
      onClose={() => setIsOpen(false)}
      {...dropdownProps}
    >
      <EmojiPickerMenu onEmojiSelect={onEmojiClick} />
    </Dropdown>
  );
};

EmojiPicker.propTypes = {
  /**
   * Function to be called when an emoji is selected
   */
  onSelect: PropTypes.func,
  /**
   * Props to be passed to the dropdown component.
   */
  dropdownProps: PropTypes.shape({
    strategy: PropTypes.oneOf(Object.values(["absolute", "fixed"])),
  }),
  /**
   * Whether to open the emoji picker by default or not.
   */
  open: PropTypes.bool,
};

export default EmojiPicker;
